import React from 'react'
import Menu from './components/Menu'
import FooterHome from './components/FooterHome'
import { LayoutWithStandardHeader as Layout, LayoutSidebar, Box } from 'stylist'
import { NavLink, Switch, Redirect, Route } from 'react-router-dom'
import RouteCompanies from 'routes/admin/companies'
import RouteCompany from 'routes/admin/companies/company'
import RouteCompanyNew from 'routes/admin/companies/new'
import RouteUsers from 'routes/admin/users'
import RouteUser from 'routes/admin/users/user'
import RouteUserNew from 'routes/admin/users/new'
import RouteProducts from 'routes/admin/products'
import RouteProduct from 'routes/admin/products/product'
import RouteFeatures from 'routes/admin/features'
import RouteFeature from 'routes/admin/features/feature'
import RouteServers from 'routes/admin/servers'
import RouteServersNew from 'routes/admin/servers/new'
import RouteServer from 'routes/admin/servers/server'
import styled from '@emotion/styled'

export const StyledLink = styled(NavLink)`
  &.${props => props.activeClassName} {
    font-weight: bold;
  }
`;

const { Content, Sidebar } = LayoutSidebar
const { Item } = Box

const RouteAdmin = ({ match: { path, url } }) => (
  <Layout>
    <Layout.Header homeRoute="/">
      <Menu />
    </Layout.Header>
    <Layout.Main>
      <LayoutSidebar>
        <Sidebar>
          <Box ghost>
            <Item>
              <StyledLink to={`${url}/companies`} >
                Companies
              </StyledLink>
            </Item>
            <Item>
              <StyledLink to={`${url}/users`} >
                Users
              </StyledLink>
            </Item>
            <Item>
              <StyledLink to={`${url}/products`} >
                Products
              </StyledLink>
            </Item>
            <Item>
              <StyledLink to={`${url}/servers`} >
                Servers
              </StyledLink>
            </Item>
            <Item>
              <StyledLink to={`${url}/features`} >
                Feature Flags
              </StyledLink>
            </Item>
          </Box>
        </Sidebar>
        <Content>
          <Switch>
            <Route
              path={path}
              exact
              render={() => <Redirect to={{ pathname: `${url}/companies` }} />}
            />
            <Route
              path={`${path}/companies`}
              exact
              component={RouteCompanies}
            />
            <Route path={`${path}/companies/new`} component={RouteCompanyNew} />
            <Route path={`${path}/companies/:id`} component={RouteCompany} />
            <Route path={`${path}/users`} exact component={RouteUsers} />
            <Route path={`${path}/users/new`} component={RouteUserNew} />
            <Route path={`${path}/users/:id`} component={RouteUser} />
            <Route path={`${path}/products`} exact component={RouteProducts} />
            <Route path={`${path}/products/:id`} component={RouteProduct} />
            <Route path={`${path}/features`} exact component={RouteFeatures} />
            <Route path={`${path}/features/:name`} component={RouteFeature} />
            <Route path={`${path}/servers`} exact component={RouteServers} />
            <Route
              path={`${path}/servers/new`}
              exact
              component={RouteServersNew}
            />
            <Route path={`${path}/servers/:id`} component={RouteServer} />
          </Switch>
        </Content>
      </LayoutSidebar>
    </Layout.Main>
    <Layout.Footer dark>
      <FooterHome />
    </Layout.Footer>
  </Layout>
)

export default RouteAdmin



// WEBPACK FOOTER //
// ./src/routes/admin.js